import React from "react";
import { ModalSettings } from "../../services/visualLibraryService";
import { i18n } from "../../services/i18nService";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { TextStyled } from "../../components/GlobalModal/styles/Styled";
import { getAppState, withAppState } from "../../state";

const defaultFocusPath = "deletedProfile";

const DeletedProfile = ({ history }) => {
  const [i, setI] = React.useState(10);

  React.useEffect(() => {
    const interval = setInterval(() => {
      if (i === 0) {
        getAppState().isProfileDeletedModal = false;
        history.replace("/profile-selector");
        clearInterval(interval);
      } else {
        setI(prevI => prevI - 1);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [i]);

  return (
    <ModalSettings
      headingText={i18n.get("global.errors.multiProfile.deletedProfileErrorEessageHeader")}
      mainText={i18n.get("global.errors.multiProfile.deletedProfileErrorMessageText")}
      isShowBackground={true}
    >
      <TextStyled
        text={`${i18n.get("global.errors.multiProfile.deletedProfileErrorMessageTime", i < 10 ? `0${i}` : i)}`}
        size="medium"
      />
    </ModalSettings>
  );
};

const Component = withAppState(withSubtheme(DeletedProfile));

Component.defaultFocusPath = defaultFocusPath;

export default Component;
